import { APIQuery } from "./api.base";
import { APIResponse } from "../types/api.types";

export const login = async (token: string): Promise<APIResponse> => {
    return await APIQuery('/user/get/me', 'GET', [], undefined, token);
};

export const getToken = async (code: string): Promise<APIResponse> => {
    return await APIQuery('/auth/token/', 'POST', [], { auth_code: code });
}

export const logout = async (): Promise<APIResponse> => {
    return await APIQuery('/auth/logout/', 'GET', []);
};
